import translation from './translation.json';
import errors from './errors.json';
import notifications from './notifications.json';

export default { translation, errors, notifications };
